import { useFeatureFlags } from '@usap/core'
import getCookieRegex from '../helpers/getCookieRegex'

export const usePasAddToCartEnabled = () => {
  const { f78 } = useFeatureFlags()
    const enabled = new Set(['b', '1', 1, 'on', 'true', true])

    return enabled.has(f78 as string | number | boolean)
}

export const usePasAddToCartCookie = () => {
  const { f78 } = useFeatureFlags()
  const f78CookieWindow = getCookieRegex('f78')

  if (f78CookieWindow) {
    return f78CookieWindow
  }

  if (f78) {
    return f78
  }

  return null
}
